import { useQuery } from '@tanstack/react-query';

import type { CampaignResponse } from 'clients/CampaignsClient/CampaignsClient.types';

import { campaignsClient } from 'clients/CampaignsClient/CampaignsClient';
import { logger } from 'config/logger';
import { queryClient } from 'config/queryClient';
import { usePageContext } from 'hooks/shared/usePageContext';
import { PageContext } from 'hooks/shared/usePageContext.types';
import { CampaignJobboard } from 'shared/legacy/contexts/SelectedCampaignContext/SelectedCampaignContext.types';
import { QueryKey } from 'types/query';

export const useCampaign = (id: number | undefined) => {
  const pageContext = usePageContext();

  const enabled = id !== undefined && pageContext !== PageContext.CentralInbox;

  const { data: campaign, isLoading } = useQuery(
    [QueryKey.campaignManagerContextUseCampaign, id],
    async () => {
      if (!id) {
        logger.error('Campaign id not defined');

        throw Error('Campaign id not defined');
      }

      const { data: campaign } = await campaignsClient.getCampaign(id);

      if (campaign.current_filter.filters.sources.length === 0) {
        campaign.current_filter.filters.sources = Object.values(CampaignJobboard);
      }

      return campaign;
    },
    { enabled },
  );

  return { campaign, isFetching: enabled && isLoading };
};

export const setCampaign = (id: number | undefined, cb: (data: CampaignResponse) => CampaignResponse) => {
  queryClient.setQueryData<CampaignResponse>([QueryKey.campaignManagerContextUseCampaign, id], (data) => {
    if (!data) throw Error('Campaign is undefined');

    return cb(data);
  });
};
